export const id = "haagbrown_app";
export const author = "Gateway Apps, LLC";
export const version = "4.2.1";
export const buildId = "4.2.1-tags/4.2.1.1131";
export const commit = "91ddb82";
export const buildTime = 1750798726525;
export const parcelProjectId = "5b1ebca99b969e09255b1ac8";
export const isProduction = true;